import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import Icon from 'carbon-react/lib/components/icon';

import styles from './ui-wizard-flow-saving.scss';

interface UIWizardFlowSavingProps {
  className?: string;
  style?: React.CSSProperties;
}

export const UIWizardFlowSaving = ({ className, style }: UIWizardFlowSavingProps) => (
  <div className={clsx(styles.savingContainer, className)} style={style}>
    <Icon type="save" className={styles.savingIcon} fontSize="small" color="#008146" />
    <FormattedMessage id={'common.saving_please_wait'} defaultMessage="Saving, please wait..." />
  </div>
);
